import { render, staticRenderFns } from "./CreateTax.vue?vue&type=template&id=c8b7ca4c"
import script from "./CreateTax.vue?vue&type=script&lang=js"
export * from "./CreateTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports